import { Injectable } from '@angular/core';
import { RepositoryBase } from '@asm/features/sync/repositories/repository-base';
import { T682I } from '@asm/features/sync/models/pricing-tables.model';

@Injectable({ providedIn: 'root' })
export class T682IRepository extends RepositoryBase<T682I> {
  protected readonly KEY_PATH = 't682i';
}
